import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allVirtualRouters: [],
  virtualRouter: null,
  virtualRoutersByCustomerID: [],
  virtualRoutersSelectedRow: {},
  createdVirtualRouter: null,
  updatedVirtualRouter: null, // { index: index of router in routers table, updatedRouter: updated router data }
  deletedVirtualRouter: null, // Index of deleted router in routers table
  retireVirtualRouter: null,
  syncVirtualRouter: null,
  virtualRouterQuota: null,
  remainingQuota: null,
  isLoading: true,
  error: [],
};

const virtualRouterSlice = createSlice({
  name: 'virtualRouter',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = [];
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setAllVirtualRouters: (state, action) => {
      state.allVirtualRouters = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setSyncVirtualRouters: (state, action) => {
      state.syncVirtualRouter = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setVirtualRouter: (state, action) => {
      state.isLoading = false;
      state.virtualRouter = action.payload;
      state.error = [];
    },
    setVirtualRoutersByCustomerID: (state, action) => {
      state.isLoading = false;
      state.virtualRoutersByCustomerID = action.payload;
      state.error = [];
    },
    setVirtualRoutersSelectedRow: (state, action) => {
      state.isLoading = false;
      state.virtualRoutersSelectedRow = action.payload;
      state.error = [];
    },
    setCreatedVirtualRouter: (state, action) => {
      state.isLoading = false;
      state.createdVirtualRouter = action.payload;
      state.error = [];
    },
    setUpdatedVirtualRouter: (state, action) => {
      state.isLoading = false;
      state.updatedVirtualRouter = action.payload;
      state.error = [];
    },
    setDeletedVirtualRouter: (state, action) => {
      state.isLoading = false;
      state.deletedVirtualRouter = action.payload;
      state.error = [];
    },
    setRetireVirtualRouter: (state, action) => {
      state.isLoading = false;
      state.retireVirtualRouter = action.payload;
      state.error = [];
    },
    setVirtualRouterQuota: (state, action) => {
      state.virtualRouterQuota = action.payload;
      state.isLoading = false;
    },
    setRemainingQuota: (state, action) => {
      state.remainingQuota = action.payload;
      state.isLoading = false;
    },
    setResetVirtualRouter: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllVirtualRouters,
  setVirtualRouter,
  setVirtualRoutersByCustomerID,
  setCreatedVirtualRouter,
  setUpdatedVirtualRouter,
  setDeletedVirtualRouter,
  setRetireVirtualRouter,
  setSyncVirtualRouters,
  setVirtualRouterQuota,
  setRemainingQuota,
  setVirtualRoutersSelectedRow,
  setResetVirtualRouter,
} = virtualRouterSlice.actions;

export default virtualRouterSlice.reducer;
